import { Text } from '@components/ui/typography'
import { motion, MotionValue, useTransform } from 'framer-motion'
import React, { FC } from 'react'
import * as styles from './styles'

const labels = [
  {
    label: 'Vegetation',
    x: 15,
    y: 35,
  },
  {
    label: 'Vegetation',
    x: 20,
    y: 85,
  },
  {
    label: 'Sky',
    x: 65,
    y: 15,
  },
  {
    label: 'Vegetation',
    x: 85,
    y: 65,
  },
  {
    label: 'Person',
    x: 55,
    y: 65,
  },
]

type LabelsProps = {
  scrollY: MotionValue<number>
  start: number
  windowHeight: number
}

export const Labels: FC<LabelsProps> = ({ scrollY, start, windowHeight }) => {
  const y = useTransform(scrollY, [start, start + windowHeight * 2], [60, -60])
  return (
    <motion.div className={styles.labelContainer} style={{ y }}>
      {labels.map((item) => (
        <span
          className={styles.label}
          style={{ left: `${item.x}%`, top: `${item.y}%` }}
          key={item.x}
        >
          <Text variant="bodyRegular" className={styles.labelTitle}>
            {item.label}
          </Text>
        </span>
      ))}
    </motion.div>
  )
}
